import React from "react";
import ArrowElbow from "../../assets/icons/arrow-elbow-down-right.svg";
import classes from "./Features.module.css";
import { Feature } from "../../Components/index";
import services from "../../assets/json/services.json";

//  TEMP :
import Startup from "../../assets/images/startup-business.png";
import Network from "../../assets/images/connections.png";
import Investment from "../../assets/images/investment.png";

function Features() {
  // TEMP
  const images = [Startup, Network, Investment];

  const featuresList = services
    .filter((service) => service.features)
    .map((feature, index) => {
      return (
        <div key={feature.id} className={classes.FeaturesContainer}>
          <img
            className={classes.FeaturesImg}
            src={images[index]}
            alt=""
            // style={props}
          />
          <div className={classes.FeaturesContent}>
            <h4 className={classes.FeaturesSubHeading}>
              Building {feature.title}
            </h4>
            <h3 className={classes.FeaturesHeading}>
              <span>{feature.title}</span> Center
            </h3>
            <p className={classes.FeaturesText}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab
              facilis sint possimus.
            </p>
            <ul className={classes.FeaturesList}>
              {feature.features.map((f, index) => (
                <Feature key={index} src={ArrowElbow} text={f} />
              ))}
            </ul>
          </div>
        </div>
      );
    });

  return <section className={classes.Features}>{featuresList}</section>;
}

export default Features;
